import React from "react";
import ArticleIcon from "@/images/icons/ArticleIcon";
import OpenOutlineIcon from "@/images/icons/OpenOutlineIcon";
import "./ResourceGuide.scss";

function ResourceGuide() {
  return (
    <div className="resource-guide">
      <ArticleIcon />
      <div className="resource-guide__content">
        <a
          href="https://amiralearning.com/hubfs/Customer_Resources/ALERTS_Check_Engagement.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="resource-guide__title"
        >
          A Teacher's Guide
          <OpenOutlineIcon width={16} height={16} color="#80089D" />
        </a>
        <span className="resource-guide__description">
          Step-by-step on how to handle low student engagement.
        </span>
      </div>
    </div>
  );
}

export default ResourceGuide;
